import isEmpty from 'lodash/isEmpty'
import { call, put, takeLeading } from 'redux-saga/effects'
import { type ActionType, getType } from 'typesafe-actions'
import { deleter, get, post } from '@/utils/api'
import { type AccessVenueType } from './access.types'
import { type RollerVenuesType } from '@/pages/[org_id]/marketplace/apps/roller/roller.types'
import * as actions from './organisations.actions'
import { type LinkGeneratorType } from './organisations.types'

function* createOrganisationLinks(
  action: ActionType<typeof actions.createOrganisationLinks.request>
) {
  try {
    const response: { payload: LinkGeneratorType } = yield call(async () =>
      post(`/generate`, action.payload, null, 'url_generator')
    )

    yield put(actions.createOrganisationLinks.success(response.payload))
  } catch (error) {
    yield put(actions.createOrganisationLinks.failure(error.status))
  }
}

function* getOrganisationLinks(
  action: ActionType<typeof actions.getOrganisationLinks.request>
) {
  try {
    const response: { payload: LinkGeneratorType[] } = yield call(async () =>
      post(`/urls`, action.payload, null, 'url_generator')
    )

    yield put(actions.getOrganisationLinks.success(response.payload))
  } catch (error) {
    yield put(actions.getOrganisationLinks.failure(error.status))
  }
}

function* getAccessBookingsVenuesSaga(
  action: ActionType<typeof actions.getAccessBookingsVenues.request>
) {
  try {
    const {
      body,
    }: {
      body: { data: { venues: AccessVenueType[] } }
    } = yield call(async () =>
      get(`/${action.payload.orgId}/access/venues`, 'booking_integration')
    )

    yield put(actions.getAccessBookingsVenues.success(body.data.venues))
  } catch (error) {
    yield put(actions.getAccessBookingsVenues.failure(error))
  }
}

function* getRollerBookingsVenuesSaga(
  action: ActionType<typeof actions.getRollerData.request>
) {
  try {
    const response: Record<string, RollerVenuesType> = yield call(async () =>
      get(`/${action.payload.orgId}/roller/venues`, 'booking_integration')
    )

    yield put(actions.getRollerData.success(response ? response : {}))
  } catch (error) {
    yield put(actions.getRollerData.failure(error))
  }
}

function* postRollerBookingsVenuesSaga(
  action: ActionType<typeof actions.postRollerData.request>
) {
  try {
    const response: {
      pk: string
      venues: Record<string, RollerVenuesType>
    } = yield call(async () =>
      post(
        `/${action.payload.orgId}/roller/venues`,
        action.payload.venues,
        null,
        'booking_integration'
      )
    )

    yield put(actions.postRollerData.success(response.venues))
  } catch (error) {
    yield put(actions.postRollerData.failure(error))
  }
}

function* deleteRollerBookingsVenuesSaga(
  action: ActionType<typeof actions.deleteRollerData.request>
) {
  try {
    yield call(async () =>
      deleter(
        `/${action.payload.orgId}/roller/venues?serial=${action.payload.serial}`,
        null,
        'booking_integration'
      )
    )

    yield put(actions.deleteRollerData.success(action.payload))
  } catch (error) {
    yield put(actions.deleteRollerData.failure(error))
  }
}

export function* watchOrganisationRequest() {
  yield takeLeading(
    getType(actions.getRollerData.request),
    getRollerBookingsVenuesSaga
  )
  yield takeLeading(
    getType(actions.postRollerData.request),
    postRollerBookingsVenuesSaga
  )
  yield takeLeading(
    getType(actions.deleteRollerData.request),
    deleteRollerBookingsVenuesSaga
  )

  yield takeLeading(
    getType(actions.getAccessBookingsVenues.request),
    getAccessBookingsVenuesSaga
  )
  yield takeLeading(
    getType(actions.createOrganisationLinks.request),
    createOrganisationLinks
  )

  yield takeLeading(
    getType(actions.getAccessBookingsVenues.request),
    getAccessBookingsVenuesSaga
  )
  yield takeLeading(
    getType(actions.createOrganisationLinks.request),
    createOrganisationLinks
  )
  yield takeLeading(
    getType(actions.getOrganisationLinks.request),
    getOrganisationLinks
  )
}

export default [watchOrganisationRequest]
